import "./FormInvoivce.css";
import {useContext, useEffect, useRef, useState} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import {SetPrintDataContext} from "../../Pages/index";

import "./Form.scss";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";

export default function FormBill({id, invoiceId, primaryKey, data, hasDate}) {
  const formDOM = useRef(null);
  const [fromBack, setFromBack] = useState(0);

  const SetPrintDataContextInFormBill = useContext(SetPrintDataContext);
  const navigate = useNavigate();

  let sendArrayData = [];
  let sendArrayDate = [];
  const onclickHandlerFormBill = (e) => {
    e.preventDefault();
    // please Empty Arrays
    sendArrayData = [];
    sendArrayDate = [];
    // console.log(e);
    let elements = formDOM.current.getElementsByTagName("input");
    // import Data to sendArrayDATA
    for (let element of elements) {
      if (element.checked) {
        if (element.id == "today" || element.id == "inDate") {
          continue;
        }
        // console.log(element.value);
        sendArrayData.push(element.value);
      }
    }
    // import Data to sendArrayDATE
    for (let element of elements) {
      if (element.checked) {
        if (element.id === "today") {
          sendArrayDate.push("today");
        }
        if (element.id === "inDate") {
          sendArrayDate.push("inDate");
        }
      }
    }
    for (let element of elements) {
      if (sendArrayDate.includes("inDate")) {
        if (element.type === "text") {
          sendArrayDate.push(element.value);
        }
      }
    }

    _axios.get(prefixUrl() + '/kprint/' + '?pkValue=' + primaryKey + '&invoice=' + invoiceId
      + '&options=' + JSON.stringify(sendArrayData) + '&date=' + JSON.stringify(sendArrayDate)
    )
      .then((response) => {
        response.data.type = "HAVALEANBAR";
        SetPrintDataContextInFormBill(response.data);
        navigate("/factorprint");
      })
      .catch((error) => console.error(error));
  };

  const [show, setShow] = useState(false);

  const radioButtonShowDateHandler = (e) => {
    const {name, value} = e.target;
    if (value === "today") {
      setShow(false);
    }
    if (value === "inDate") {
      setShow(true);
    }
  };

  return (
    <>
      <form ref={formDOM}>
        <div className="form0" action="#">
          {/* mrm15*/}
          <div className={"row rowChanges0 mb-20"}>
            {data.map((row, index = 0) => (
              <div
                key={row.label}
                className={"col-5 d-flex   py-2 aroudMapModal"}
              >
                <input
                  className="form-check-input  ml-radio0"
                  type="checkbox"
                  name="data"
                  value={row.value}
                  id={row.value}
                />
                <label
                  className="form-check-label px-2 d-block"
                  htmlFor={row.value}
                >
                  {row.label}
                </label>
              </div>
            ))}
            {hasDate ? (
              <div className={"aroudDateModal py-2"}>
                <div
                  onChange={radioButtonShowDateHandler}
                  className="col-12 d-flex justify-content-around py-2 "
                >
                  <div> مشاهده به صورت:</div>
                  <div className="d-flex">
                    <input
                      className="form-check-input   ml-radio0"
                      type={"radio"}
                      name="date"
                      value={"today"}
                      id={"today"}
                    />
                    <label
                      className="form-check-label px-2 d-block"
                      htmlFor={"today"}
                    >
                      روزانه
                    </label>
                  </div>
                  <div className="d-flex">
                    <input
                      className="form-check-input  ml-radio0"
                      type={"radio"}
                      name="date"
                      value={"inDate"}
                      id={"inDate"}
                    />
                    <label
                      className="form-check-label px-2 d-block"
                      htmlFor={"inDate"}
                    >
                      در بازه تاریخ
                    </label>
                  </div>
                </div>
                <div
                  className={
                    "col-120 d-flex justify-content-around " +
                    `${show ? "d-block" : "d-none"}`
                  }
                >
                  <div className="d-flex">
                    <div className="form-control">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="از تاریخ"
                        name={"fromDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="form-control">
                      <DatePicker
                        calendar={persian}
                        className="form-control"
                        placeholder="تا تاریخ"
                        name={"toDate"}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <span></span>
            )}
          </div>
        </div>
        <div className="modal-footer mt-4">
          <button
            onClick={onclickHandlerFormBill}
            className="btn btnCustom btnSubmit btn-modal shadow m-auto px-4"
            data-bs-target="#exampleModalToggle2"
            data-bs-toggle="modal"
            data-bs-dismiss="modal"
          >
            ثبت{" "}
          </button>
        </div>
      </form>
    </>
  );
}
